import React, { ComponentProps } from "react";

function CloseIcon({ stroke, ...restProps }: ComponentProps<"svg">) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g id="Group 37313">
        <path
          id="Stroke 1"
          d="M1.21108 1.2108L10.7893 10.7891"
          stroke={stroke || "white"}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 2"
          d="M10.7913 1.20642L1.20312 10.7946"
          stroke={stroke || "white"}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default CloseIcon;
